var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWebhook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20841 22547)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    transform: "translate(-20841 -22547)",
    fill: "#434e6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.241,28.965a6.006,6.006,0,0,1-4.4-1.84A6.006,6.006,0,0,1,4,22.724,6.068,6.068,0,0,1,5.281,18.88,5.994,5.994,0,0,1,8.6,16.712v2.069a4.275,4.275,0,0,0-1.38,6.964,4.116,4.116,0,0,0,3.022,1.248,4.262,4.262,0,0,0,4.27-4.27v-.985h8.179a2.057,2.057,0,0,1,.624-.476,1.6,1.6,0,0,1,.723-.181,1.626,1.626,0,0,1,1.642,1.642,1.6,1.6,0,0,1-.476,1.15,1.559,1.559,0,0,1-1.166.493,1.6,1.6,0,0,1-.723-.181,2.057,2.057,0,0,1-.624-.476H16.417a6.571,6.571,0,0,1-2.184,3.761A5.911,5.911,0,0,1,10.241,28.965Zm13.8,0a5.992,5.992,0,0,1-2.907-.723,6.45,6.45,0,0,1-2.184-1.905h2.825a3.789,3.789,0,0,0,1.068.493,4.343,4.343,0,0,0,1.2.164A4.274,4.274,0,0,0,27.06,19.7a4.116,4.116,0,0,0-3.022-1.248,4.236,4.236,0,0,0-1.15.148,4.167,4.167,0,0,0-1.018.443l-4.237-7.161a1.925,1.925,0,0,1-1.068-.575,1.516,1.516,0,0,1-.411-1.068,1.559,1.559,0,0,1,.493-1.166A1.6,1.6,0,0,1,17.8,8.6a1.626,1.626,0,0,1,1.642,1.642,1.744,1.744,0,0,1-.016.246,2.864,2.864,0,0,1-.082.345l3.383,5.781q.361-.066.706-.1t.608-.033a6.225,6.225,0,0,1,6.241,6.241,6.252,6.252,0,0,1-6.241,6.241Zm-13.8-4.6A1.684,1.684,0,0,1,8.6,22.724a1.475,1.475,0,0,1,.411-1.035,2.107,2.107,0,0,1,1.035-.608l3.646-6.143a7.463,7.463,0,0,1-1.56-2.152,5.814,5.814,0,0,1-.575-2.546,5.99,5.99,0,0,1,1.84-4.418,6.228,6.228,0,0,1,8.7-.1,6.045,6.045,0,0,1,1.938,4.188H22.067A4,4,0,0,0,20.736,7.1,4.193,4.193,0,0,0,17.8,5.971a4.262,4.262,0,0,0-4.27,4.27,4.1,4.1,0,0,0,.8,2.48,4.369,4.369,0,0,0,2.053,1.56L11.752,22.1a3.545,3.545,0,0,1,.1.345,1.289,1.289,0,0,1,.033.279,1.6,1.6,0,0,1-.476,1.15A1.559,1.559,0,0,1,10.241,24.366Z",
    transform: "translate(-20834.139 -22541.482)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWebhook);
export default __webpack_public_path__ + "static/media/logo-webhook.6449659786cead3f3f5171a896767b6e.svg";
export { ForwardRef as ReactComponent };